export default "__VITE_ASSET__gLfjQN2F38TvQ8VCM7mJ4g__"